import { Component, h } from 'preact';
import * as appStyles from '../../../assets/global.scss';
import Icon from '../../../common/Icon/Icon';
import { Properties, TravelClass, getKey, Key } from '../../../common';
import { Row } from '../../../common/Layout/Layout';
import { withStyles, WithStyles } from '../../../style';
import { stopPropagation, isRadio } from '../../../utils';
import { FinText } from '../../../i18n';

export interface TravelClassRadioProps extends Properties {
  value: TravelClass;
  checked: boolean;
  onSelection: (travelClass: TravelClass) => any;
  enableCompactWidget: boolean;
}

type EffectiveProps = TravelClassRadioProps & WithStyles;

@withStyles(appStyles)
export default class TravelClassRadio extends Component<TravelClassRadioProps> {
  setTravelClass = (e: MouseEvent, hideModal: boolean): void => {
    const { onSelection, value } = this.props;
    onSelection(value);

    // As navigating radio buttons with arrowKeys will fire click events
    // we check whether or not the event originates from keyboard navigation
    // (radio) or normal click and close the modal only if it's a genuine click
    if (hideModal && !isRadio(e.target as HTMLElement)) {
      this.hideModal();
    }
  };

  handleKeyUp = (e: KeyboardEvent, hideModal: boolean) => {
    if (getKey(e) === Key.ENTER) {
      stopPropagation(e);
      if (hideModal) {
        this.hideModal();
      }
    }
  };

  hideModal = (): void => {
    const {
      modal: { hideModal },
    } = this.context;
    hideModal();
  };

  render({ value, checked, tx, enableCompactWidget }: EffectiveProps): h.JSX.Element {
    return (
      <Row class={tx(this.props.class, `travelClass-${value}`, 'flex--space-between')} grow={false} fill={false}>
        <input
          class={'is-vishidden'}
          id={`travelClass-${value}`}
          type="radio"
          name="travelClass"
          value={value}
          onKeyUp={(e) => this.handleKeyUp(e, !enableCompactWidget)}
          checked={checked}
          autofocus={checked}
        />
        <label
          for={`travelClass-${value}`}
          class={tx('cursor-pointer', 'font-body-1 ps-medium-y fill nordic-blue-900-text')}
          onClick={(e) => this.setTravelClass(e, !enableCompactWidget)}
        >
          <FinText id={`travelClass.${enableCompactWidget && value === TravelClass.MIXED ? 'mixedCombined' : value}`} />
        </label>
        {checked && <Icon class={tx('is-small nordic-blue-900-text')} iconName="checkmark" />}
      </Row>
    );
  }
}
